import React, { useEffect, useState } from "react";

const UserModal = ({ isOpen, onClose, user, roles, onSubmit, loading, onCreateRole, invitationLink }) => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    roleId: "",
  });
  const [errors, setErrors] = useState({});
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || user.name || "",
        email: user.invitedEmail || "",
        roleId: user.roleId || "",
      });
    } else {
      setFormData({ username: "", email: "", roleId: "" });
    }
    setErrors({});
    setCopied(false);
  }, [user, isOpen]);

  if (!isOpen) return null;

  const validate = () => {
    const newErrors = {};
    if (!formData.username.trim()) newErrors.username = "Username is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }
    if (!formData.roleId) newErrors.roleId = "Role is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formData);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(invitationLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="modal-overlays" onClick={onClose}>
      <div className="modals" onClick={(e) => e.stopPropagation()}>
        <div className="modals-header">
          <h2>
            {invitationLink ? "Invitation Ready!" : (user ? "Edit User" : "Add New User")}
          </h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {invitationLink ? (
          <div className="success-view">
            <div className="success-icon">✓</div>
            <p>The invitation for <strong>{formData.email}</strong> is ready.</p>
            <div className="link-box">
              <input type="text" value={invitationLink} readOnly />
              <button onClick={handleCopy} className="btn-copy">
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
            <p className="hint-text">You can share this link manually if the email notification doesn't arrive.</p>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={onClose}>Done</button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Username <span className="required">*</span></label>
              <input
                type="text"
                name="username"
                placeholder="Enter username"
                value={formData.username}
                onChange={handleChange}
                className={errors.username ? "input-error" : ""}
              />
              {errors.username && <span className="error-text">{errors.username}</span>}
            </div>

            <div className="form-group">
              <label>Email <span className="required">*</span></label>
              <input
                type="email"
                name="email"
                placeholder="user@example.com"
                value={formData.email}
                onChange={handleChange}
                disabled={!!user}
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label>Role <span className="required">*</span></label>
              <select
                name="roleId"
                value={formData.roleId}
                onChange={handleChange}
                className={errors.roleId ? "input-error" : ""}
              >
                <option value="">Select role...</option>
                {roles?.map((role) => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
              {errors.roleId && <span className="error-text">{errors.roleId}</span>}
            </div>

            {!user && (
              <div className="label-row">
                <button type="button" className="link-btn" onClick={onCreateRole}>
                  + Create Role
                </button>
              </div>
            )}

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? (user ? "Saving..." : "Adding...") : (user ? "Save Changes" : "Add User")}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default UserModal;
